// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const app = angular.module('landingPage');

app.directive('giHomeSlider', ($interval, $compile) => ({
  link(scope, elem, attr) {
    const matchAssetId = /[^\/]*(?=[.][a-zA-Z]+$)/;
    let slideShow = null;
    const slideTag = attr.giHomeSlider || 'img';

    scope.slides = elem.find('> ' + slideTag);

    const setActiveSlide = function (index) {
      scope.activeSlide = index;
      $(scope.slides).removeClass('active');
      $(scope.slides[index]).addClass('active');
      const imageData = $(scope.slides[index]).data();
      scope.isource = imageData.isource;
      scope.link = imageData.link;
      scope.linkText = imageData.linkText;
      if (slideTag === 'img') {
        return (scope.assetId = scope.slides[index].src.match(matchAssetId)[0]);
      }
    };

    const nextSlide = function () {
      if (scope.slides.length - 1 > scope.activeSlide) {
        return setActiveSlide(scope.activeSlide + 1);
      } else {
        return setActiveSlide(0);
      }
    };

    const previousSlide = function () {
      if (scope.activeSlide < 1) {
        return setActiveSlide(scope.slides.length - 1);
      } else {
        return setActiveSlide(scope.activeSlide - 1);
      }
    };

    scope.clickNext = function () {
      nextSlide();
      return startSlideShow();
    };

    scope.clickPrev = function () {
      previousSlide();
      return startSlideShow();
    };

    const sliderFooter = function () {
      const footerHtml =
        '<footer><a data-isource="gi_us_home_hero_{{isource}}_1" ng-href="/detail/{{assetId}}" target="_self">' +
        t('home.view_image') +
        '</a><span ng-show="linkText">|</span><a ng-show="linkText" data-isource="gi_us_home_hero_{{isource}}_2" ng-href="{{link}}" target="_self">{{linkText}}</a></footer><a class="slidePrev" ng-click="clickPrev()"></a><a class="slideNext" ng-click="clickNext()"></a>';
      const footer = $compile(footerHtml)(scope);
      return elem.append(footer);
    };

    var startSlideShow = function () {
      if (slideShow) {
        $interval.cancel(slideShow);
      }
      return (slideShow = $interval(() => nextSlide(), 5000));
    };

    sliderFooter();
    setActiveSlide(0);
    return startSlideShow();
  },
}));
